import { c as _c } from "react/compiler-runtime";
interface OptionActionButtonsProps {
  onCartClick: () => void;
  onBuyClick: () => void;
  cartDisabled?: boolean;
  buyDisabled?: boolean;
  cartLabel?: string;
  buyLabel?: string;
}
export const OptionActionButtons = t0 => {
  const $ = _c(11);
  const {
    onCartClick,
    onBuyClick,
    cartDisabled,
    buyDisabled,
    cartLabel: t1,
    buyLabel: t2
  } = t0;
  const cartLabel = t1 === undefined ? "\uC7A5\uBC14\uAD6C\uB2C8 \uB2F4\uAE30" : t1;
  const buyLabel = t2 === undefined ? "\uBC14\uB85C\uAD6C\uB9E4" : t2;
  let t3;
  if ($[0] !== cartDisabled || $[1] !== cartLabel || $[2] !== onCartClick) {
    t3 = <button type="button" onClick={onCartClick} disabled={cartDisabled} className="flex h-56 flex-1 items-center justify-center border border-O-400 font-700 text-O-400 typo-body3 disabled:opacity-50">{cartLabel}</button>;
    $[0] = cartDisabled;
    $[1] = cartLabel;
    $[2] = onCartClick;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== buyDisabled || $[5] !== buyLabel || $[6] !== onBuyClick) {
    t4 = <button type="button" onClick={onBuyClick} disabled={buyDisabled} className="flex h-56 flex-1 items-center justify-center bg-O-400 font-700 text-Gray-white typo-body3 disabled:opacity-50">{buyLabel}</button>;
    $[4] = buyDisabled;
    $[5] = buyLabel;
    $[6] = onBuyClick;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t3 || $[9] !== t4) {
    t5 = <div className="flex gap-8">{t3}{t4}</div>;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
};